export default __webpack_public_path__ + "static/hultbrochureshape-bf31394a43e318fd94ec698bb97c2959.png";